import React, { Component } from 'react';
import { Container, Input, Div, Button } from './InputArea.style';
import i18n from '../../../i18n';
import { connect } from 'react-redux';
class InputArea extends Component {
    handleKeyPress = (e) => {
        if (e.key === "Enter") {
            this.props.onClick()
        }
    }
    render() {
        const { onChange, textValue, onClick, padding, fontSize, margin, minWidth, setInputRef, id, setFocus, handleBlurInputField } = this.props
        return (
            <Container margin={margin}>
                <Input onFocus={() => setFocus(id)} onBlur={handleBlurInputField} ref={ref => setInputRef(id, ref)} fontSize={fontSize} padding={padding} maxLength={200} onKeyPress={this.handleKeyPress} value={textValue} onChange={onChange} placeholder={i18n.t("web.gallery.comment.placeholder")} />
                <Button minWidth={minWidth} fontSize={fontSize} padding={padding} onClick={onClick}>{i18n.t("web.gallery.comment.btn")}</Button>
            </Container>
        );
    }
}


const mapStateToProps = state => ({
    lang: state.langStore.lang,

})

export default connect(
    mapStateToProps,
    null
)(InputArea)
